export default __webpack_public_path__ + "static/media/blob_06.42361fa9.mp4";